import React, { Component, createElement, Fragment } from 'react';
import { message, Table, Modal } from 'antd';
import { connect } from 'react-redux';
import { ComponentsManager } from '@comall-backend-builder/core';
import { Entity } from '@comall-backend-builder/core/lib/parser';
import { actions, services } from '@comall-backend-builder/core';
import { ShowProductsUploadButton } from '../show-products-upload-button';
import { get } from 'lodash';

import { errorHandle } from '../../services';

const api = services.api;

export interface LiveFilterAttrTableProps {
    entity: Entity;
    params: any;
    componentId: string;
    selectedRowKeys: string[];
}

interface IState {
    selectedKeys: any;
    showUploadModal: boolean;
    showFailPop: boolean;
    failNum: number;
    successNum: number;
    totalNum: number;
    importTableData: object[];
    importColumns: object[];
}

class liveProductsTable extends Component<LiveFilterAttrTableProps, IState> {
    constructor(props: any) {
        super(props);
        this.state = {
            selectedKeys: [],
            showUploadModal: false,
            showFailPop: false,
            failNum: 0,
            successNum: 0,
            totalNum: 0,
            importTableData: [],
            importColumns: [
                {
                    title: 'SKU编码',
                    dataIndex: 'skuCode',
                    key: 'skuCode',
                },
                {
                    title: '商品名称',
                    dataIndex: 'name',
                    key: 'name',
                },
                {
                    title: '价格类型',
                    dataIndex: 'priceType',
                    key: 'priceType',
                },
                {
                    title: 'Price1(价格)',
                    dataIndex: 'priceFirst',
                    key: 'priceFirst',
                },
                {
                    title: 'Price2(价格)',
                    dataIndex: 'priceSecond',
                    key: 'priceSecond',
                },
                {
                    title: '失败原因',
                    dataIndex: 'msg',
                    key: 'msg',
                },
            ],
        };
        // this.onAdd = this.onAdd.bind(this);
        this.onDeleteBatch = this.onDeleteBatch.bind(this);
        this.onRefreshBatch = this.onRefreshBatch.bind(this);
        this.onDeleteAll = this.onDeleteAll.bind(this);
        this.showModal = this.showModal.bind(this);
        this.closeFailPop = this.closeFailPop.bind(this);
    }

    showModal() {
        let { showUploadModal } = this.state;
        this.setState({
            showUploadModal: !showUploadModal,
        });
    }

    closeFailPop() {
        let { showFailPop } = this.state;
        this.setState({
            showFailPop: !showFailPop,
        });
    }

    toggleUploadModalFun = (data) => {
        console.log('我有值啦', data);
        if (data) {
            if (data.resultCode && data.resultCode == 200) {
                message.success('批量导入商品信息成功,稍后刷新查看', 3);
            } else {
                if (
                    data?.resultCode == 500 &&
                    data?.resultMsg ===
                        '在数据导入时，请等待上一次导入完成后再进行新的请求，避免重复处理。'
                ) {
                    message.error(data?.resultMsg, 3);
                } else {
                    this.setState({
                        showFailPop: true,
                        importTableData: data?.resultBody?.failList || [],
                        failNum: data?.resultBody?.failNum || 0,
                        successNum: data?.resultBody?.successNum || 0,
                        totalNum: data?.resultBody?.totalNum || 0,
                    });
                }
            }
        }
        this.setState({
            showUploadModal: !this.state.showUploadModal,
        });
    };

    onDeleteBatch() {
        const { entity, params } = this.props;
        const { selectedKeys } = this.state;
        if (selectedKeys.length == 0) {
            message.warning('请至少选择一项');
        } else {
            api.post(selectedKeys, { apiPath: `/live/products/batchDel` })
                .then(() => {
                    // 列表数据刷新
                    entity.search({
                        ...entity.params,
                        ...entity.filters,
                    });
                })
                .catch(errorHandle);
        }
    }

    onRefreshBatch() {
        const { entity, params } = this.props;
        const { selectedKeys } = this.state;
        if (selectedKeys.length == 0) {
            message.warning('请至少选择一项');
        } else {
            api.post(selectedKeys, { apiPath: `/live/products/batchRefresh` })
                .then(() => {
                    // 列表数据刷新
                    entity.search({
                        ...entity.params,
                        ...entity.filters,
                    });
                })
                .catch(errorHandle);
        }
    }

    onDeleteAll() {
        const {
            entity: {
                filters,
                paging: { page, perPage },
            },
        } = this.props;

        const params = {
            page,
            perPage,
            ...filters,
        };
        api.get(params, { apiPath: `/products/skuBlackList/export` })
            .then(() => {
                message.success('导出成功，请到 报表管理 - 报表导出管理 中查看');
            })
            .catch(errorHandle);
    }

    renderControllers() {
        const layoutProps = {
            component: 'FlexLayout',
            direction: 'horizontal',
            style: {
                marginBottom: 16,
            },
            align: 'start',
            items: [
                {
                    component: 'Button',
                    span: 3,
                    type: 'primary',
                    text: '添加商品',
                    route: '/live-product/add',
                    style: {
                        marginRight: 16,
                        flexGrow: 0,
                    },
                },
                {
                    component: 'LiveProductRefreshButton',
                    span: 3,
                    text: '全部刷新',
                    type: 'primary',
                    style: {
                        flexGrow: 0,
                        marginRight: 16,
                    },
                },
                {
                    component: 'Button',
                    text: '批量添加商品',
                    type: 'primary',
                    span: 4,
                    style: { marginBottom: '20px' },
                    onClick: this.showModal,
                },
                {
                    component: 'Button',
                    text: '批量删除',
                    type: 'default',
                    span: 3,
                    style: { marginBottom: '20px' },
                    onClick: this.onDeleteBatch,
                },
                {
                    component: 'Button',
                    text: '批量刷新',
                    type: 'default',
                    span: 3,
                    style: { marginBottom: '20px' },
                    onClick: this.onRefreshBatch,
                },
                {
                    component: 'ExportButton',
                    text: '下载模板',
                    type: 'default',
                    source: {
                        apiPath: '/templates/IMPORT_LIVE_ROOM_SKU',
                    },
                    span: 3,
                    style: { marginBottom: '20px' },
                },
                // {
                //     component: 'UploadButton',
                //     span: 3,
                //     buttons: {
                //         text: '导入黑名单',
                //         type: 'primary',
                //     },
                //     maxSize: 100 * 1024,
                //     successTitle: '导入成功，请稍后查看',
                //     failTitle: '导入失败了',
                //     accept: '.xls,.xlsx,.csv',
                //     action: '/templates/ADD_BLACK_LIST',
                //     className: 'upload-button',
                // },
                // {
                //     component: 'Button',
                //     text: '导出黑名单',
                //     type: 'primary',
                //     span: 3,
                //     style: { marginBottom: '20px' },
                //     onClick: this.onDeleteAll,
                // },
            ],
        };
        return createElement(ComponentsManager.get('GridLayout'), layoutProps);
    }

    renderTable() {
        const { entity, componentId } = this.props;
        const tableProps = {
            entity,
            rowKey: 'id',
            componentId: componentId + '-Table',
            loadFirstPage: true,
            rowSelection: {
                onChange: (selectedKeys: string[]) => {
                    this.setState({
                        selectedKeys,
                    });
                },
            },
            pagination: {
                pageSize: 10,
                showSizeChanger: true,
                showQuickJumper: true,
                pageSizeOptions: ['10', '15', '20'],
                showTotal(total: number) {
                    return `共 ${total} 条记录`;
                },
            },
            scroll: {
                x: true,
            },
            columns: [
                {
                    property: 'skuId',
                },
                {
                    property: 'skuCode',
                    width: 220,
                },
                {
                    property: 'name',
                    width: 220,
                },
                {
                    property: 'imgUrl',
                    width: 100,
                    displayConfig: {
                        style: {
                            width: 50,
                            height: 50,
                        },
                        preview: {
                            visible: true,
                            size: 400,
                            placement: 'right',
                        },
                    },
                },
                {
                    property: 'priceType',
                },
                {
                    property: 'price',
                },
                {
                    property: 'status',
                },
            ],
            actionColumn: {
                title: '操作',
                width: 160,
                fixed: 'right',
                style: {
                    height: '80px',
                },
                items: [
                    {
                        type: 'component',
                        component: 'LiveProductActionButton',
                    },
                ],
            },
        };
        return createElement(ComponentsManager.get('DataTable'), tableProps);
    }

    render() {
        const {
            showUploadModal,
            showFailPop,
            totalNum,
            successNum,
            failNum,
            importTableData,
            importColumns,
        } = this.state;
        let uploadPropsObj = {
            showUploadModal: showUploadModal,
            toggleUploadModal: this.toggleUploadModalFun.bind(this),
            type: 'liveProduct',
        };
        return (
            <Fragment>
                {this.renderControllers()}
                {this.renderTable()}
                {showUploadModal && <ShowProductsUploadButton {...uploadPropsObj} />}

                <Modal
                    visible={showFailPop}
                    destroyOnClose={true}
                    maskClosable={false}
                    centered
                    title="错误信息"
                    onOk={this.closeFailPop}
                    onCancel={this.closeFailPop}
                >
                    <p style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <span>
                            总条数：<b>{totalNum}</b>
                        </span>
                        <span>
                            正常条数：<b style={{ color: 'green' }}>{successNum}</b>
                        </span>
                        <span>
                            异常条数：<b style={{ color: 'red' }}>{failNum}</b>
                        </span>
                    </p>
                    <p style={{ color: 'red' }}>skn校验错误信息如下，请修正后重新上传！</p>
                    <div style={{ maxHeight: '300px', overflowY: 'scroll' }}>
                        <Table
                            rowKey="skn"
                            columns={importColumns}
                            dataSource={importTableData}
                            pagination={false}
                        />
                    </div>
                </Modal>
            </Fragment>
        );
    }
}

export const LiveProductsTable = connect()(liveProductsTable);
